export default "__VITE_ASSET__zsvZ8c6n__"